var map = {
	"./addMore.svg": "23b6",
	"./alert.svg": "6c40",
	"./arrow.svg": "b94f",
	"./bookmark.svg": "42f9",
	"./close.svg": "bf37",
	"./close_transparent.svg": "b577",
	"./close_transparent_white.svg": "f4f7",
	"./close_white.svg": "c3dc",
	"./createSos.svg": "86ab",
	"./createSosTest.svg": "51bd",
	"./delete.svg": "d739",
	"./duplicate.svg": "8c42",
	"./edit.svg": "6582",
	"./home.svg": "86e6",
	"./logo.svg": "9b19",
	"./machine.svg": "223b",
	"./machine_white.svg": "7b8e",
	"./machinered.svg": "5f14",
	"./more.svg": "f51c",
	"./more_white.svg": "465a",
	"./move.svg": "b62d",
	"./moveDown.svg": "dfc1",
	"./moveUp.svg": "e060",
	"./open.svg": "5713",
	"./open_transparent.svg": "a633",
	"./open_transparent_white.svg": "fa64",
	"./open_white.svg": "90e5",
	"./qr_code_icon.svg": "ec2c",
	"./setStart.svg": "895f",
	"./share.svg": "6f2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";